import Parse from 'html-react-parser';

function BMP20256(props) {
    let svgCode =
    `<svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="36" height="36" stroke="${props.highlightColour}" stroke-width="2"/>
        <path d="M6 32L6.65746 24.8899L13.1808 31.1037L6 32Z" fill="${props.highlightColour}"/>
        <path d="M15.0137 29.4997L8.5585 23.3507L19.9723 11.692L26.4275 17.841L15.0137 29.4997Z" fill="${props.highlightColour}"/>
        <path d="M28.2039 16.0265L21.7487 9.87753L25.5448 6L32 12.149L28.2039 16.0265Z" fill="${props.highlightColour}"/>
    </svg>`

    props.svgReturn(64, svgCode, "bmp00256", 38, 38);

    const style = {
        position: "absolute",
        overflow: "hidden",
        height: "50px",
        top: "294px",
        left: "782px",
        display: props.display
    }

    const inStyle = {
        marginTop: "0px"
    }

    return (
        <div style={style}>
            <div style={inStyle}>
            {Parse(svgCode)}
            </div>
        </div>
    );
}

export default BMP20256;